import { Locales } from './models/locales.model'
import { PromoVacModel } from './models/promoVac.model'
import { createClient } from 'contentful'

const client = createClient({
  space: process.env.CONTENTFUL_SPACE_ID,
  accessToken: process.env.CONTENTFUL_DELIVERY_TOKEN,
  environment: process.env.CONTENTFUL_ENVIRONMENT,
})

/**
* Locale detection
**/
const getLocale = (): Locales => {
  // Safe fallback during build
  if (typeof window === 'undefined') {
    return (process.env.LANGUAGE as Locales) || ('en-CA' as Locales)
  }

  const path = window.location.pathname.toLowerCase()

  const isFrench =
    path === '/fr' || path.startsWith('/fr/')

  return isFrench
    ? ('fr-CA' as Locales)
    : ('en-CA' as Locales)
}

export const fetcher = async () => {
  const locale: Locales = getLocale()

  const entryItems = await client.getEntries<PromoVacModel>({
    content_type: 'promoVac',
    locale,
  })

  const entries = entryItems.items.map((entry) => {
    const { fields } = entry

    return fields
      ? {
          meta: fields.metaData?.fields,
          header: {
            logo: fields.logo?.fields,
            languageUrl: fields.languageUrl,
            phone: fields.phone,
            email: fields.email,
            locale,
          },
          content: {
            notification: fields.notification,
            sectionTextImage: {
              text: fields.sectionTextImageText,
              image: fields.sectionTextImageImage?.fields,
            },
            ctaButton: fields.ctaButton,
            ctaButtonSecondary: fields.ctaButtonSecondary,
            sectionReason: {
              title: fields.reasonTitle,
              cards: fields.reasonCards,
            },
            symptoms: fields.symptoms,
            sectionTestimonials: {
              text: fields.testimonials,
              image: {
                url:
                  fields.testimonialsBackgroundImage?.fields?.file?.url,
                alt:
                  fields.testimonialsBackgroundImage?.fields?.title,
              },
            },
            sectionImageText: {
              text: fields.sectionImageTextText,
              image: fields.sectionImageTextImage?.fields,
            },
          },
          footer: {
            copyright: fields.copyright,
            terms: fields.terms,
            privacy: fields.privacy,
          },
        }
      : {}
  })

  return { entry: entries[0] }
}